import angular from 'angular'
import noaccessComponent from './noaccess.component'
import NoAccessController from './noaccess.controller'

export default angular
  .module('ellipsis.noaccess', [])
  .component('noaccess', noaccessComponent)
  .controller('NoAccessController', NoAccessController)
